import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ExcelService } from 'src/app/domain/excel';
import { ExcelTemplateName } from 'src/app/domain/excel/interfaces';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { Router } from '@angular/router';
import { MarketAnalysisByVintageChartDTO } from '../../../dto/MaByIndustryChartDTO';

@Component({
  selector: 'app-ma-vintage-table',
  templateUrl: './ma-vintage-table.component.html',
  styleUrls: ['./ma-vintage-table.component.scss'],
})
export class MarketAnalysisByVintageTableComponent implements OnChanges {
  @Input() marketData: MarketAnalysisByVintageChartDTO;
  @Input() selectedOrg: Organization;

  // Store the index of the selected Fund row to be highlighted (only one row, due to business logic)
  selectedFundRow: number;

  constructor(private excelService: ExcelService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.marketData && this.marketData) {
      this.calculateHighlightedRow();
    }
  }

  exportExcel(): void {
    const isRecovery = this.router.url.split('?')[0] === '/recovery';
    const fundName = isRecovery ? 'recovery' : this.selectedOrg.selectedFund.name;
    if (fundName) {
      const fileName = `market-returns-per-vintage-VC-${fundName}.xlsx`;
      this.excelService.exportByTemplate(this.marketData, fileName, ExcelTemplateName.maVintageTable);
    }
  }

  /**
   * Method to calculate which row should be highlighted based on the first non-null value in selectedFundArr
   */
  private calculateHighlightedRow(): void {
    this.selectedFundRow = this.marketData.tvpiChartData.periodsArr.findIndex((_, index) =>
      this.marketData.tvpiChartData.selectedFundArr[index] !== null ||
      this.marketData.netIrrChartData.selectedFundArr[index] !== null ||
      this.marketData.moicChartData.selectedFundArr[index] !== null ||
      this.marketData.grossIrrChartData.selectedFundArr[index] !== null ||
      this.marketData.contributionChartData.selectedFundArr[index] !== null,
    );
  }

}
